export enum downloadsTitle {
    errorRips = 'El reporte RIPS presenta problemas de validación. ',
    notificationRips = 'Notificaciones en la validación de RIPS.',
    successDocument = 'El proceso de exportación se realizó con éxito',
}
export enum downloadsDescription {
    errorRips = 'Revise el archivo de log descargado para conocer el detalle.',
    notificationRips = 'Revise el archivo de log para más detalles sobre las notificaciones.',
    successDocument = 'Archivo con log de Auditoría descargado',
}